import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Link,
} from "@chakra-ui/react";

import React from "react";
import styled from "styled-components";

export type Breadcrumb = {
  label: string;
  link?: string;
};

type BreadcrumbProps = {
  crumbs: Breadcrumb[];
  px?: any;
};

const Div = styled.div`
  ol {
    display: flex;
    flex-wrap: wrap;
  }
`;

const Breadcrumbs = ({ crumbs, px }: BreadcrumbProps) => {
  return (
    <Div>
      <Breadcrumb
        px={px}
        py={3}
        bg="#F7FAFC"
        separator={"/"}
        mt={{ base: "60px", lg: "152px" }}
      >
        {crumbs.map((crumb: any, index: any) => (
          <BreadcrumbItem fontSize={{ base: "sm", md: "md" }} key={index}>
            {crumb.link ? (
              <BreadcrumbLink
                as={Link}
                href={`https://www.medsupplysolutions.com${crumb.link}`}
              >
                {crumb.label}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink textDecoration="none" isCurrentPage>
                {crumb.label}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </Div>
  );
};

export default Breadcrumbs;
